module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-21.6bf6d3de.png";